import { createStyles, Theme } from '@zn-material-ui'
import iconBackImg from '@images/login/icon_back.png'

export default (theme: Theme) =>
  createStyles({
    unionLogin: {
      display: 'flex',
      alignItems: 'center',
      marginTop: '30px',
      marginRight: '20px',
      opacity: 0.66,
      fontSize: '16px',
      color: '#333333',
      letterSpacing: '0',
      textAlign: 'center',
      cursor: 'pointer',
      '& .title': {
        marginLeft: '7px',
      },
    },
    switchLang: {
      position: 'absolute',
      top: '30px',
      right: '49px',
    },
    loginContainer: {
      minWidth: '531px',
      paddingLeft: '69px',
      display: 'block',
    },
    loginForm: {
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      position: 'relative',
    },
    back: {
      width: '120px',
      height: '120px',
      backgroundColor: '#F9FAFC',
      backgroundImage: `url(${iconBackImg})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      cursor: 'pointer',
      position: 'absolute',
      top: 0,
      left: 0,
    },
    hello: {
      color: '#F4F5F8',
      fontSize: 40,
      letterSpacing: 0,
    },
    welcome: {
      marginTop: 10,
      fontSize: 40,
      color: '#363C46',
      letterSpacing: 0,
      fontWeight: 600,
    },
    welcomeTit: {
      display: 'inline-block',
    },
    titleLine: {
      width: 40,
      height: 5,
      marginTop: 18,
      backgroundColor: theme.palette.primary.main,
    },
    formContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.secondary.main,
    },
    loginButtonComp: {
      width: '460px',
    },
    btnDisabled: {
      opacity: '0.5',
      cursor: 'not-allowed',
      pointerEvents: 'none',
    },
    loginOther: {
      display: 'flex',
    }
  })
